import axios from 'axios';
import environment from 'environment';

import { JsonResponse, Pagination } from 'core/models/response';
import { Currency } from '../models/currencies';

interface GetCurrenciesResponse {
	currencies: Currency[];
	pagination: Pagination;
}

export interface CreateCurrencyPayload {
	name: {
		en: string;
		ar: string;
	};
	active: 1 | 0;
	code: string;
	default: 1 | 0;
}

export const onGetCurrencies = (page = 1) => {
	return axios.get<JsonResponse<GetCurrenciesResponse>>(`${environment.BASE_API_ENDPOINT}/admin/currencies`, {
		params: {
			page,
		},
	});
};

export const onGetCurrency = (currencyId: string) => {
	return axios.get<JsonResponse<Currency>>(`${environment.BASE_API_ENDPOINT}/admin/currencies/${currencyId}`);
};

export const onCreateCurrency = (data: CreateCurrencyPayload) => {
	return axios.post<JsonResponse<Currency>>(`${environment.BASE_API_ENDPOINT}/admin/currencies`, data);
};

export const onUpdateCurrency = (currencyId: string, data: Partial<CreateCurrencyPayload>) => {
	return axios.put<JsonResponse<Currency>>(`${environment.BASE_API_ENDPOINT}/admin/currencies/${currencyId}`, data);
};

export const onDeleteCurrency = (currencyId: number) => {
	return axios.delete(`${environment.BASE_API_ENDPOINT}/admin/currencies/${currencyId}`);
};
